import type { Marker } from '../maps';

export enum ConnectionType {
  NONE,
  CAR,
  WALK,
  BICYCLE,
  FLIGHT,
  FERRY,
}

export interface RouteConnection {
  from: Marker;
  to: Marker;
  type: ConnectionType;
}

export type Route = RouteConnection[];

export interface RouteConnectionWithDetails extends RouteConnection {
  expectedTravelTimeInMinutes: number | undefined;
  distanceInKilometers: number | undefined;
}

export type RouteWithDetails = RouteConnectionWithDetails[];

export interface RouteSegmentByConnectionType {
  segment: Route;
  type: ConnectionType;
}

export interface RouteSegmentBoundaries {
  from: Marker;
  to: Marker;
  waypoints: Marker[];
  type: ConnectionType;
}
